export default "__VITE_ASSET__rpyvEEUc__"